import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  ScheduleTasks as ScheduleTasksGenerated,
  ScheduleTasksVariables as ScheduleTasksVariablesGenerated,
} from "core/queries/__generated__/ScheduleTasks";

export interface ScheduleTasksResponse extends ScheduleTasksGenerated {}
export interface ScheduleTasksVariables
  extends ScheduleTasksVariablesGenerated {}

export const scheduleTasks = gql`
  mutation ScheduleTasks(
    $cityId: ID!
    $endAt: RFC3339DateTime!
    $startAt: RFC3339DateTime!
    $taskIds: [ID!]!
  ) {
    scheduleTasks(
      cityId: $cityId
      endAt: $endAt
      startAt: $startAt
      taskIds: $taskIds
    ) {
      success
    }
  }
`;

interface UseScheduleTasksQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
}
export const useScheduleTasks = ({
  refetchQueries = [],
  awaitRefetchQueries = false,
}: UseScheduleTasksQueryOptions) =>
  useMutation<ScheduleTasksResponse, ScheduleTasksVariables>(scheduleTasks, {
    refetchQueries,
    awaitRefetchQueries,
  });
